import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  bounce_right_to_left_variants_delay,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";
import skipArrow from "assets/images/tot/skip-arrow.png";
import scoreTick from "assets/images/tot/score-tick.png";

const GuessingBeforeAction = ({
  word,
  isGuesser,
  right_words,
  onScoreSkip,
  skipped_words,
  category_image,
  current_category
}) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tot-guesser"
    >
      {isGuesser ? (
        <motion.div
          variants={bounce_right_to_left_variants_without_children}
          className="guesser-category-div"
        >
          <h2 className="name">{current_category}</h2>
          <div className="score-skip-div">
            <div className="guessed">
              <span>Guessed</span>
              <h2>{right_words.length}</h2>
            </div>
            <div className="guessed skipped">
              <span>Skipped</span>
              <h2>{skipped_words.length}</h2>
            </div>
          </div>
        </motion.div>
      ) : (
        <motion.div
          variants={bounce_right_to_left_variants_without_children}
          className="clue-giver-category-div"
        >
          <h2 className="name">{current_category}</h2>
          <img alt="" src={category_image} />
          <h1>{word}</h1>
        </motion.div>
      )}
      {isGuesser ? (
        <motion.button
          variants={bounce_right_to_left_variants_delay}
          className="tot-skip-btn"
          onClick={() => onScoreSkip("skip")}
        >
          <img alt="" src={skipArrow} />
          <span>SKIP</span>
        </motion.button>
      ) : (
        <motion.button
          variants={bounce_right_to_left_variants_delay}
          className="tot-skip-btn score"
          onClick={() => onScoreSkip("score")}
        >
          <img alt="" src={scoreTick} />
          <span>SCORE</span>
        </motion.button>
      )}
    </motion.div>
  );
};

export default GuessingBeforeAction;
